import {get, post} from '@/ulits/http'

// 团队信息

export function teamInfo(params) {
  return post('api/team-info',params)
}

// 团队成员

export function teamUser(params) {
  return post('api/team-user',params)
}

// 团队收入
export function teamIncome(params) {
  return post('api/team-order',params)
}

// 提现记录

export function withdrawList(params) {
  return post('api/withdraw-list',params)
}

//邀请码获取

export function teamCode(params) {
  return post('api/team-code',params)
}

// 申请提现
export function withdrawApply (params) {
  return post('api/withdraw-apply', params)
}

// 可提现金额
export function withdrawBalance (params) {
  return post('api/withdraw-balance',params)
}